import { render, staticRenderFns } from "./WordDocument.vue?vue&type=template&id=0d3c17f5&"
import script from "./WordDocument.vue?vue&type=script&lang=js&"
export * from "./WordDocument.vue?vue&type=script&lang=js&"
import style0 from "./WordDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports